"use client"
import { Link } from "react-router-dom"
import Footer from "./Footer"

const HomePage = () => {
  return (
    <div className="homepage">
      {/* Hero Section */}
      <section className="hero-section">
        <div className="hero-container">
          <div className="hero-content">
            <h1 className="hero-title">
              Increase your productivity
              <br />
              very quickly with <span className="hero-highlight">Shopify Scraper</span>.
            </h1>
            <p className="hero-description">
              Did you know that most Shopify sellers with millions of sales
              <br />
              can create online stores of 1000+ products in under One minute?
            </p>
            <p className="hero-question">
              Would you also like to know this miracle solution do they pass?
              <br />
              Well the question is answered very quickly!
            </p>
            <p className="hero-product-description">
              <strong>Shopify Scraper</strong> is a powerful shopify product <strong>exporting tool</strong>.<br />
              This favorite nanny of Shopify millionaires lets you export products from any Shopify store in csv
              <br />
              format with blistering ease and speed.
            </p>
            <Link to="/home" className="download-button">
              Try It Now
            </Link>
          </div>
          <div className="hero-image">
            <img
              src="/images/1.png"
              alt="Shopify Scraper illustration"
              className="hero-illustration"
            />
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section className="features-section">
        <div className="features-container">
          <div className="features-image">
            <img
              src="/images/2.png"
              alt="Features illustration"
              className="features-illustration"
            />
          </div>
          <div className="features-content">
            <h2 className="features-title">
              We Provide Many
              <br />
              Features You Can Use
            </h2>
            <p className="features-description">
              You can explore the features that we provide with fun and have their own functions each feature.
            </p>
            <ul className="features-list">
              <li className="feature-item">
                <span className="feature-check">✓</span>
                One click to export all products to csv file
              </li>
              <li className="feature-item">
                <span className="feature-check">✓</span>
                Export products for <strong>Shopify or Woocommerce</strong>
              </li>
              <li className="feature-item">
                <span className="feature-check">✓</span>
                Select the specified collections to export
              </li>
              <li className="feature-item">
                <span className="feature-check">✓</span>
                Select the specified products to export
              </li>
              <li className="feature-item">
                <span className="feature-check">✓</span>
                Search the specified products to export
              </li>
              <li className="feature-item">
                <span className="feature-check">✓</span>
                Show detail of specified product
              </li>
            </ul>
          </div>
        </div>
      </section>

      {/* How It Works Section */}
      <section className="how-it-works-section">
        <div className="how-it-works-container">
          <h2 className="section-title">How It Works</h2>
          <div className="steps-container">
            <div className="step">
              <div className="step-number">1</div>
              <h3 className="step-title">Install Extension</h3>
              <p className="step-description">Download and install our Chrome extension from the Chrome Web Store</p>
            </div>
            <div className="step">
              <div className="step-number">2</div>
              <h3 className="step-title">Visit Shopify Store</h3>
              <p className="step-description">Navigate to any Shopify store you want to extract data from</p>
            </div>
            <div className="step">
              <div className="step-number">3</div>
              <h3 className="step-title">Export Products</h3>
              <p className="step-description">Click the extension icon and export products with one click</p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="cta-section">
        <div className="cta-container">
          <h2 className="cta-title">Ready to boost your productivity?</h2>
          <p className="cta-description">Join thousands of Shopify store owners who are saving time and effort</p>
          <div className="cta-buttons">
            <Link to="/home" className="cta-button primary">
              Try It Now
            </Link>
            <Link to="/pricing" className="cta-button secondary">
              View Pricing
            </Link>
          </div>
        </div>
      </section>


      {/* Styling */}
      <style jsx="true">{`
        /* Hero Section */
        .hero-section {
          padding: 4rem 0;
          background-color: #fff;
        }
        
        .hero-container {
          max-width: 1200px;
          margin: 0 auto;
          padding: 0 1.5rem;
          display: flex;
          align-items: center;
          justify-content: space-between;
        }
        
        .hero-content {
          flex: 1;
          max-width: 600px;
        }
        
        .hero-title {
          font-size: 2.5rem;
          font-weight: 700;
          line-height: 1.2;
          margin-bottom: 1.5rem;
          color: #1a202c;
        }
        
        .hero-highlight {
          color: #007BFF;
        }
        
        .hero-description, .hero-question, .hero-product-description {
          margin-bottom: 1.5rem;
          font-size: 1rem;
          line-height: 1.6;
          color: #4a5568;
        }
        
        .download-button {
          display: inline-block;
          background-color: #f33a3a;
          color: white;
          font-weight: 600;
          padding: 0.75rem 1.5rem;
          border-radius: 0.375rem;
          text-decoration: none;
          transition: background-color 0.2s;
          margin-top: 1rem;
        }
        
        .download-button:hover {
          background-color: #e02e2e;
        }
        
        .hero-image {
          flex: 1;
          display: flex;
          justify-content: center;
        }
        
        .hero-illustration {
          max-width: 100%;
          height: auto;
        }
        
        /* Features Section */
        .features-section {
          padding: 4rem 0;
          background-color: #f9fafb;
        }
        
        .features-container {
          max-width: 1200px;
          margin: 0 auto;
          padding: 0 1.5rem;
          display: flex;
          align-items: center;
          justify-content: space-between;
        }
        
        .features-image {
          flex: 1;
          display: flex;
          justify-content: center;
        }
        
        .features-content {
          flex: 1;
          max-width: 600px;
        }
        
        .features-title {
          font-size: 2.25rem;
          font-weight: 700;
          line-height: 1.2;
          margin-bottom: 1.5rem;
          color: #1a202c;
        }
        
        .features-description {
          margin-bottom: 1.5rem;
          font-size: 1rem;
          line-height: 1.6;
          color: #4a5568;
        }
        
        .features-list {
          list-style: none;
          padding: 0;
        }
        
        .feature-item {
          display: flex;
          align-items: center;
          margin-bottom: 1rem;
          font-size: 1rem;
          color: #4a5568;
        }
        
        .feature-check {
          color: #007BFF;
          font-weight: bold;
          margin-right: 0.75rem;
          font-size: 1.25rem;
        }
        
        /* How It Works Section */
        .how-it-works-section {
          padding: 4rem 0;
          background-color: #fff;
        }
        
        .how-it-works-container {
          max-width: 1200px;
          margin: 0 auto;
          padding: 0 1.5rem;
          text-align: center;
        }
        
        .section-title {
          font-size: 2.25rem;
          font-weight: 700;
          margin-bottom: 3rem;
          color: #1a202c;
        }
        
        .steps-container {
          display: flex;
          justify-content: space-between;
          flex-wrap: wrap;
          gap: 2rem;
        }
        
        .step {
          flex: 1;
          min-width: 250px;
          padding: 2rem;
          background-color: #f9fafb;
          border-radius: 0.5rem;
          box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);
        }
        
        .step-number {
          width: 3rem;
          height: 3rem;
          background-color: #007BFF;
          color: white;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 1.5rem;
          font-weight: 700;
          margin: 0 auto 1.5rem;
        }
        
        .step-title {
          font-size: 1.25rem;
          font-weight: 600;
          margin-bottom: 1rem;
          color: #1a202c;
        }
        
        .step-description {
          font-size: 1rem;
          color: #4a5568;
          line-height: 1.6;
        }
        
        /* CTA Section */
        .cta-section {
          padding: 4rem 0;
          background-color: #007BFF;
          color: white;
        }
        
        .cta-container {
          max-width: 1200px;
          margin: 0 auto;
          padding: 0 1.5rem;
          text-align: center;
        }
        
        .cta-title {
          font-size: 2.25rem;
          font-weight: 700;
          margin-bottom: 1rem;
        }
        
        .cta-description {
          font-size: 1.125rem;
          margin-bottom: 2rem;
          opacity: 0.9;
        }
        
        .cta-buttons {
          display: flex;
          justify-content: center;
          gap: 1rem;
          flex-wrap: wrap;
        }
        
        .cta-button {
          padding: 0.75rem 1.5rem;
          border-radius: 0.375rem;
          font-weight: 600;
          text-decoration: none;
          transition: all 0.2s;
        }
        
        .cta-button.primary {
          background-color: white;
          color: #007BFF;
        }
        
        .cta-button.primary:hover {
          background-color: #f9fafb;
        }
        
        .cta-button.secondary {
          background-color: transparent;
          border: 2px solid white;
          color: white;
        }
        
        .cta-button.secondary:hover {
          background-color: rgba(255, 255, 255, 0.1);
        }
        
        /* Responsive Styles */
        @media (max-width: 1024px) {
          .hero-container, .features-container {
            flex-direction: column;
            text-align: center;
          }
          
          .hero-content, .features-content {
            max-width: 100%;
            margin-bottom: 2rem;
          }
          
          .features-list {
            display: inline-block;
            text-align: left;
          }
        }
        
        @media (max-width: 768px) {
          .hero-title {
            font-size: 2rem;
          }
          
          .features-title, .section-title, .cta-title {
            font-size: 1.75rem;
          }
          
          .steps-container {
            flex-direction: column;
          }
        }
      `}</style>
    </div>
  )
}

export default HomePage
